import React from 'react';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';

import IconLaptop from './IconLaptop';
import IconSignal from './IconSignal';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    iconLaptop: {
      fontSize: 13,
      marginRight: unit / 2,
    },
  });

interface Props {
  classes: any;
}

const IconTelehealthOnline: React.FC<Props> = ({ classes }) => (
  <>
    <IconLaptop className={classes.iconLaptop} fill="#59BF94" />
    <IconSignal size={12} />
  </>
);

export default withStyles(styles)(IconTelehealthOnline);
